// extracted by mini-css-extract-plugin
export default {"container":"AddReview_container__nKjI8","form":"AddReview_form__80QJh","dropDown":"AddReview_dropDown__SdxTc"};